export const PROFILE_STEPS = {
  WELCOME: 0,
  JOB_ROLE: 1,
  SKILLS: 2,
  JOB_INTEREST: 3,
  SKILL_GOAL: 4,
  COMPLETION: 5,
};
